export const enBackendMessages = {
  errors: {
    accountLocked: `Account temporarily locked due to multiple failed login attempts. Try again in {{remaining_time}} minutes.`,
    accountLockedAttemptsRemaining: `Incorrect email or password. {{attempts_left_until_lock}} attempts remaining before account lockout.`,
    accountLockedOneMoreAttempt: `Incorrect email or password. One more failed attempt will lock your account for 15 minutes.`,
    answerNotFound: `No answer found for question: {{question_key}}`,
    answerQuestionKeyInvalid: `Invalid question_key. Must be in format 'question_1' through 'question_8'`,
    appleIapInvalidJson: `Invalid JSON payload`,
    appleIapMissingSignedPayload: `Missing signedPayload`,
    appleIapWebhookProcessingFailed: `Webhook processing failed`,
    chatArchivalTaskFailed: `Failed to queue archival task: {{error}}`,
    chatCeleryTestFailed: `Failed to queue Celery test tasks: {{error}}`,
    chatQueryTooLong: `Query is too long to process`,
    chatRulesRefreshFailed: `Failed to refresh chat rules: {{error}}`,
    chatSessionAlreadyClosed: `Session {{session_id}} is already closed`,
    chatSessionCloseAllFailed: `Failed to close sessions: {{error}}`,
    chatSessionCloseFailed: `Failed to close session: {{error}}`,
    chatSessionGetActiveFailed: `Failed to get active sessions: {{error}}`,
    chatSessionNotFound: `Chat session not found`,
    chatStreamError: `An error occurred in the chat stream. Please try again.`,
    decryptionFailed: `Unable to decrypt stored data. Please contact support.`,
    encryptionServiceNotConfigured: `Encryption service is not properly configured. Please contact support.`,
    expiredProviderToken: `Your Google or Apple sign-in session expired. Please try again.`,
    fileDocxExceedsSizeLimit: `DOCX exceeds size limit`,
    fileImageExceedsSizeLimit: `Image exceeds size limit`,
    fileImageTypeNotAllowed: `Image type {{subtype}} not allowed`,
    fileInsufficientPermissions: `Not enough permissions`,
    fileNotFound: `File not found`,
    filePdfExceedsSizeLimit: `PDF exceeds size limit`,
    fileReadFailed: `Failed to read file: {{error}}`,
    fileSizeExceedsLimit: `File size exceeds maximum allowed size of {{max_size}} bytes`,
    fileTooManyFiles: `Too many files. Maximum {{max_files}} files allowed per upload.`,
    fileTooManyFilesAttached: `Too many files attached. Maximum {{max_files}} files allowed per message.`,
    fileTypeNotAllowed: `File type {{file_type}} is not allowed`,
    fileUploadAzureFailed: `Failed to upload file to Azure`,
    fileUploadFailed: `Upload failed: {{error}}`,
    googlePlayInvalidBase64Json: `Invalid base64/json: {{error}}`,
    googlePlayInvalidEnvelope: `Invalid envelope: {{error}}`,
    googlePlayMissingMessageIdOrData: `Missing messageId or data`,
    googlePlayMissingRequiredFields: `Missing required RTDN fields`,
    googlePlayPackageNameRequired: `Package name is required`,
    googlePlayPackageNotAllowed: `Package {{package_name}} not in allowed list`,
    googlePlayProcessingFailed: `Processing failed: {{error}}`,
    googlePlayProductIdRequired: `Product ID is required in purchase details`,
    googlePlayPurchaseDetailsRequired: `Purchase details are required`,
    googlePlayPurchaseTokenRequired: `Purchase token is required`,
    googlePlayPurchaseVerificationFailed: `Purchase verification failed: {{message}}`,
    googlePlayPurchaseVerificationFailedUnexpected: `Purchase verification failed due to an unexpected error`,
    googlePlayServiceConfigurationError: `Google Play service configuration error: {{error}}`,
    incorrectEmailOrPassword: `Incorrect email or password`,
    incorrectPassword: `Incorrect password`,
    internalServerError: `Internal Server Error`,
    invalidProviderToken: `Sign-in with Google or Apple could not be verified. Please try again.`,
    invalidRefreshToken: `Invalid refresh token`,
    invalidToken: `Invalid token`,
    invalidTokenType: `Invalid token type`,
    notAuthenticated: `Not authenticated`,
    couldNotValidateCredentials: `Could not validate credentials`,
    accountInactive: `Account is inactive or scheduled for deletion`,
    providerAuthFailed: `Sign-in with your provider failed. Please try again or use email and password instead.`,
    unsupportedProvider: `This sign-in provider is not supported.`,
    linkingRequired: `This social identity must be linked to an existing HARVN account before you can continue.`,
    accountLinkingFailed: `We couldn't link this social identity to your HARVN account. Please check your details and try again.`,
    providerUnavailable: `Social sign-in is temporarily unavailable. Please use email and password instead.`,
    onboardingIncomplete: `Your account is not fully set up yet. Please complete the required steps before continuing.`,
    accountCompletionNotRequired: `Your account is already complete. You can continue using HARVN normally.`,
    tokenExpired: `Token has expired`,
    tokenRevoked: `Token has been revoked`,
    tokenLimitExceeded: `Token limit exceeded`,
    debugTokenCheckFailed: `Error checking token: {{error}}`,
    passwordResetEmailFailed: `Failed to send password reset email. Please try again later.`,
    passwordSameAsCurrent: `New password cannot be the same as the current one`,
    passwordsDontMatch: `Passwords don't match`,
    questionnaireNotFound: `Questionnaire not found`,
    rateLimitExceeded: `Rate limit exceeded: {{limit_str}}`,
    assistantPromptNotFound: `Assistant prompt not found`,
    assistantPromptNotAuthorized: `Not authorized to access this prompt`,
    assistantPromptNotAuthorizedToActivate: `Not authorized to activate this prompt`,
    assistantPromptNotAuthorizedToDelete: `Not authorized to delete this prompt`,
    assistantPromptNotAuthorizedToUpdate: `Not authorized to update this prompt`,
    validationDateInvalid: `Invalid date format`,
    validationEmailInvalid: `Invalid email address format`,
    validationFieldRequired: `Field is required`,
    validationGeneric: `Validation error`,
    validationInvalidValue: `Invalid value`,
    validationPasswordLength: `Password must be between 8 and 40 characters`,
    validationStringTooLong: `String should have at most {{max_length}} characters`,
    validationStringTooShort: `String is too short`,
    validationTypeError: `Invalid type`,
    validationValueOutOfRange: `Value is out of allowed range`,
    rateLimitRetryAfter: `Rate limit reached. Please try again {{retry_after_formatted}}.`,
    subscriptionAdminPrivilegesRequired: `Admin privileges required`,
    subscriptionAlreadyActive: `User already has an active subscription`,
    subscriptionCancelled: `Your subscription has been cancelled. Please resubscribe.`,
    subscriptionCancelFailed: `Failed to cancel subscription`,
    subscriptionCannotDowngrade: `Active subscription present, can not downgrade`,
    subscriptionCannotSwitchToSamePlan: `Can not update to the same subscription plan`,
    subscriptionDaysAdvanceLimit: `Cannot advance more than 365 days at once`,
    subscriptionDayConsumptionFreemiumOnly: `Day consumption is only available for freemium trial users`,
    subscriptionDaysMustBePositive: `Days used must be positive`,
    subscriptionFreemiumActivationFailed: `Failed to activate freemium subscription`,
    subscriptionFreemiumExpired: `Freemium expired`,
    subscriptionFreemiumTrialEnded: `Your Freemium trial has ended. Please subscribe.`,
    subscriptionFreemiumTokensExhausted: `You've used all your freemium tokens. Please subscribe to continue.`,
    subscriptionExpired: `Your subscription has expired. Please resubscribe.`,
    subscriptionInvalidPlanChoice: `Invalid plan choice. Must be 'monthly' or 'yearly'`,
    subscriptionInvalidStatus: `Invalid subscription status.`,
    subscriptionNoActiveSubscription: `No active subscription found`,
    subscriptionNotEnoughTokensRemaining: `Not enough tokens remaining`,
    subscriptionPaymentConfigurationError: `Payment configuration error. Please contact support.`,
    subscriptionPaymentProcessingError: `Payment processing error: {{error}}`,
    subscriptionPeriodEnded: `Your subscription period has ended. Please resubscribe.`,
    subscriptionStripeConfigurationError: `Stripe configuration error: {{error}}`,
    subscriptionStripeNotAvailable: `Stripe not available`,
    subscriptionStripeNotConfigured: `Stripe not configured`,
    subscriptionTrialNotInitialized: `Trial not initialized.`,
    subscriptionUserAlreadyHasActiveSubscription: `User already has an active subscription`,
    subscriptionNoStripeSubscriptionForBillingPortal: `Payment method can only be updated for active subscriptions. No active subscription found.`,
    subscriptionNotFound: `Subscription not found`,
    subscriptionTokensMustBePositive: `Tokens used must be positive`,
    subscriptionWebhookInvalidPayload: `Invalid payload`,
    subscriptionWebhookInvalidSignature: `Invalid signature`,
    subscriptionWebhookMissingSignature: `Missing stripe-signature header`,
    subscriptionWebhookSecretNotConfigured: `Webhook secret not configured`,
    tokenAlreadyUsed: `Token already used`,
    tokenNotFound: `Token not found`,
    tooManyLoginAttempts: `Too many login attempts. Please try in {{retry_after}} seconds. {{attempts_left_until_lock}} attempts remaining until account lockout`,
    unexpectedError: `An unexpected error occurred. Please try again later.`,
    userAccountCreationFailed: `Unable to create account. Please try again or log in if you already have an account.`,
    userCannotDeleteSelf: `Super users are not allowed to delete themselves`,
    userDeletionFailed: `Failed to schedule account deletion. Please try again later.`,
    userEmailAlreadyVerified: `Email already verified`,
    userEmailExists: `Unable to update email. Please try a different one.`,
    userEmailNotVerified: `Email address not verified`,
    userEmailUpdateFailed: `Unable to update email. Please try a different one.`,
    userInactive: `Inactive user`,
    userInsufficientPrivileges: `The user doesn't have enough privileges`,
    userNotAllowed: `User not allowed`,
    userNotFound: `User not found`,
    userPrivacyNotAccepted: `Privacy Policy must be accepted to create an account`,
    userTermsNotAccepted: `Terms and Conditions must be accepted to create an account`,
    userWithEmailNotFound: `The user with this email does not exist in the system.`,
    userWithIdNotFound: `The user with this id does not exist in the system`,
    userWithUsernameNotFound: `The user with this username does not exist in the system.`,
  },
  success: {
    accountScheduledForDeletion: `Your account has been scheduled for deletion.`,
    fileDeleted: `File deleted successfully`,
    fileUploaded: `File uploaded successfully to Azure Blob Storage`,
    fileUploadedToSession: `File uploaded successfully to session storage`,
    fileUploadUrlGenerated: `Upload URL generated successfully`,
    loggedOut: `Successfully logged out`,
    passwordRecoveryEmailSent: `Password recovery email sent`,
    passwordUpdated: `Password updated successfully`,
    sessionClosed: `Session {{session_id}} closed and queued for archival`,
    userDeleted: `User deleted successfully`,
    userVerified: `User successfully verified`,
    verificationEmailSent: `User verification email re-sent successfully`,
  },
} as const;
